import { SALES_API_URL } from "../../settings/config";
import { authRequest } from "../authorizedRequests";
import { getSubscriptionPlans, userSubscription } from "./selectors";
import {
    fetchPlansFailed,
    fetchPlansInProgress,
    fetchPlansSuccess,
    fetchSubscriptionInProgress,
    fetchSubscriptionSuccess,
    fetchSubscriptionFailed
} from "./creators";

export const fetchSubscription = (_) => {
    return (dispatch, getState) => {
        const apiUrl = `${SALES_API_URL}/subscription`;

        dispatch(fetchSubscriptionInProgress());

        return authRequest(apiUrl, dispatch, getState)
            .then((response) => dispatch(fetchSubscriptionSuccess(response)))
            .catch((_) => {
                dispatch(fetchSubscriptionFailed());
            });
    };
};

export const fetchSubscriptionPlans = (_) => {
    return (dispatch, getState) => {
        const apiUrl = `${SALES_API_URL}/plans`;
        const plans = getSubscriptionPlans(getState());

        if (Object.keys(plans).length) {
            return Promise.resolve(plans);
        }

        dispatch(fetchPlansInProgress());

        authRequest(apiUrl, dispatch, getState)
            .then((response) => dispatch(fetchPlansSuccess(response)))
            .catch((_) => {
                dispatch(fetchPlansFailed());
            });
    };
};

export const sendCancellationReason = (reason, comment) => {
    return (dispatch, getState) => {
        const apiUrl = `${SALES_API_URL}/subscription/reason`;
        const subscription = userSubscription(getState());
        const planCode = subscription["plan_code"];
        const payload = {
            reason: reason,
            comment: comment,
            plan_code: planCode
        };

        return authRequest(apiUrl, dispatch, getState, {
            method: "POST",
            body: JSON.stringify(payload)
        })
            .then((response) => {
                //dispatch(sendCancellationReasonSuccessful(response));
            })
            .catch((_) => {
                //dispatch(sendCancellationReasonFailed());
            });
    };
};
